import { render, staticRenderFns } from "./CompositeInput.vue?vue&type=template&id=0546d8bc&scoped=true&"
import script from "./CompositeInput.vue?vue&type=script&lang=js&"
export * from "./CompositeInput.vue?vue&type=script&lang=js&"
import style0 from "./CompositeInput.vue?vue&type=style&index=0&id=0546d8bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0546d8bc",
  null
  
)

export default component.exports